<template>
  <div class="header_v2__container">
    <div class="logo">
      <div class="box-logo">
        <svg
          v-if="darkTheme"
          xmlns="http://www.w3.org/2000/svg"
          width="152"
          height="40"
          viewBox="0 0 152 40"
          fill="none"
        >
          <ellipse cx="19.9351" cy="19.9344" rx="12.013" ry="11.9608" fill="white" />
          <ellipse cx="19.935" cy="19.8688" rx="2.92207" ry="3.00654" fill="#007CFF" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.000488282 19.9999C0.000488282 19.9999 0.000488281 20 0.000488281 20C0.000488281 31.0457 8.95477 40 20.0004 40C31.0461 40 40.0004 31.0457 40.0004 20C40.0004 8.95431 31.0461 0 20.0004 0C20.0002 0 20 9.17134e-09 19.9998 9.17134e-09V6.27451C20 6.27451 20.0002 6.27451 20.0004 6.27451C27.6416 6.27451 33.7666 12.4581 33.7666 20C33.7666 27.5419 27.6416 33.7255 20.0004 33.7255C12.3592 33.7255 6.23424 27.5419 6.23424 20C6.23424 20 6.23424 19.9999 6.23424 19.9999H0.000488282Z"
            fill="#007CFF"
          />
          <path
            d="M16.1038 3.47656C16.1038 1.65529 17.5221 0.149052 19.3401 0.0396886L19.9999 0V6.27451H18.9017C17.3565 6.27451 16.1038 5.02183 16.1038 3.47656Z"
            fill="#007CFF"
          />
          <path
            d="M3.20319 16.7969C4.73514 16.7969 6.01965 17.9539 6.17918 19.4775L6.23389 20H7.82013e-05C7.82013e-05 18.231 1.43416 16.7969 3.20319 16.7969Z"
            fill="#007CFF"
          />
          <path
            d="M55.6063 29.8438H58.7844V20.7031C58.7844 16.3719 56.0563 14.0938 52.4281 14.0938C50.5719 14.0938 48.8563 14.8531 47.8156 16.1188V14.3469H44.6094V29.8438H47.8156V21.1813C47.8156 18.3406 49.3625 16.8781 51.725 16.8781C54.0594 16.8781 55.6063 18.3406 55.6063 21.1813V29.8438Z"
            fill="white"
          />
          <path
            d="M67.6835 29.8719L71.2835 29.8438L75.6429 15.05L79.7492 29.8438H83.3773L89.171 10.2969H85.7398L81.6617 26.1313L77.5835 10.2969H73.9835L69.596 26.2156L65.546 10.2969H62.1429L67.6835 29.8719Z"
            fill="white"
          />
          <path
            d="M92.6592 29.8438H95.8654V21.1813C95.8654 18.3406 97.4123 16.8781 99.7748 16.8781C102.109 16.8781 103.656 18.3406 103.656 21.1813V29.8438H106.834V20.7031C106.834 16.3719 104.134 14.0938 100.675 14.0938C98.6779 14.0938 96.9342 14.8531 95.8654 16.1469V9.03125H92.6592V29.8438Z"
            fill="white"
          />
          <path
            d="M118.293 16.7937C120.683 16.7937 122.568 18.3125 122.624 20.7031H114.046C114.383 18.2563 116.127 16.7937 118.293 16.7937ZM125.549 25.2313H122.09C121.499 26.4406 120.402 27.3969 118.433 27.3969C116.071 27.3969 114.243 25.85 114.018 23.2906H125.858C125.943 22.7563 125.971 22.25 125.971 21.7156C125.971 17.1594 122.849 14.0938 118.433 14.0938C113.849 14.0938 110.699 17.2156 110.699 22.0812C110.699 26.9469 113.99 30.0969 118.433 30.0969C122.23 30.0969 124.677 27.9312 125.549 25.2313Z"
            fill="white"
          />
          <path
            d="M136.495 16.7937C138.885 16.7937 140.77 18.3125 140.826 20.7031H132.248C132.585 18.2563 134.329 16.7937 136.495 16.7937ZM143.751 25.2313H140.292C139.701 26.4406 138.604 27.3969 136.635 27.3969C134.273 27.3969 132.445 25.85 132.22 23.2906H144.06C144.145 22.7563 144.173 22.25 144.173 21.7156C144.173 17.1594 141.051 14.0938 136.635 14.0938C132.051 14.0938 128.901 17.2156 128.901 22.0812C128.901 26.9469 132.192 30.0969 136.635 30.0969C140.432 30.0969 142.879 27.9312 143.751 25.2313Z"
            fill="white"
          />
          <path d="M148.172 29.8438H151.378V9.03125H148.172V29.8438Z" fill="white" />
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          width="152"
          height="41"
          viewBox="0 0 152 41"
          fill="none"
        >
          <ellipse cx="20.0169" cy="20.2003" rx="12.0623" ry="12.1203" fill="#303A46" />
          <ellipse cx="20.0166" cy="20.1345" rx="2.93407" ry="3.04662" fill="#007CFF" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.000488288 20.2672C0.000766109 31.4599 8.99172 40.5333 20.0826 40.5333C31.1736 40.5333 40.1647 31.4596 40.1647 20.2667C40.1647 9.0737 31.1736 0 20.0826 0C20.0824 0 20.0823 5.8626e-09 20.0821 5.8626e-09V6.35817C20.0823 6.35817 20.0824 6.35817 20.0826 6.35817C27.7552 6.35817 33.9053 12.6242 33.9053 20.2667C33.9053 27.9091 27.7552 34.1752 20.0826 34.1752C12.4102 34.1752 6.26012 27.9094 6.25984 20.2672H0.000488288Z"
            fill="#007CFF"
          />
          <path
            d="M16.1699 3.52292C16.1699 1.67709 17.6069 0.150265 19.4493 0.0384117L20.082 0V6.35817H19.0052C17.4393 6.35817 16.1699 5.08879 16.1699 3.52292V3.52292V3.52292Z"
            fill="#007CFF"
          />
          <path
            d="M3.21663 17.0205C4.75449 17.0205 6.04359 18.1828 6.2023 19.7124L6.25977 20.2663H0.000353086V20.2663C0.000353086 18.49 1.44033 17.0205 3.21663 17.0205V17.0205V17.0205Z"
            fill="#007CFF"
          />
          <path
            d="M55.8345 30.2423H59.0257V20.9798C59.0257 16.5908 56.2864 14.2823 52.6433 14.2823C50.7795 14.2823 49.0568 15.0518 48.0119 16.3343V14.5388H44.7925V30.2423H48.0119V21.4643C48.0119 18.5858 49.5651 17.1038 51.9373 17.1038C54.2813 17.1038 55.8345 18.5858 55.8345 21.4643V30.2423Z"
            fill="#303A46"
          />
          <path
            d="M67.9614 30.2708L71.5762 30.2423L75.9535 15.2513L80.0766 30.2423H83.7196L89.5372 10.4348H86.0918L81.9969 26.4803L77.9021 10.4348H74.2873L69.8818 26.5658L65.8151 10.4348H62.398L67.9614 30.2708Z"
            fill="#303A46"
          />
          <path
            d="M93.0396 30.2423H96.259V21.4643C96.259 18.5858 97.8123 17.1038 100.184 17.1038C102.528 17.1038 104.082 18.5858 104.082 21.4643V30.2423H107.273V20.9798C107.273 16.5908 104.562 14.2823 101.088 14.2823C99.0831 14.2823 97.3322 15.0518 96.259 16.3628V9.15234H93.0396V30.2423Z"
            fill="#303A46"
          />
          <path
            d="M118.778 17.0183C121.179 17.0183 123.071 18.5573 123.127 20.9798H114.514C114.853 18.5003 116.604 17.0183 118.778 17.0183ZM126.064 25.5683H122.591C121.998 26.7938 120.896 27.7628 118.92 27.7628C116.547 27.7628 114.712 26.1953 114.486 23.6018H126.375C126.46 23.0603 126.488 22.5473 126.488 22.0058C126.488 17.3888 123.353 14.2823 118.92 14.2823C114.316 14.2823 111.154 17.4458 111.154 22.3763C111.154 27.3068 114.458 30.4988 118.92 30.4988C122.732 30.4988 125.189 28.3043 126.064 25.5683Z"
            fill="#303A46"
          />
          <path
            d="M137.055 17.0183C139.456 17.0183 141.348 18.5573 141.404 20.9798H132.791C133.13 18.5003 134.881 17.0183 137.055 17.0183ZM144.341 25.5683H140.868C140.275 26.7938 139.173 27.7628 137.197 27.7628C134.824 27.7628 132.989 26.1953 132.763 23.6018H144.652C144.737 23.0603 144.765 22.5473 144.765 22.0058C144.765 17.3888 141.63 14.2823 137.197 14.2823C132.593 14.2823 129.43 17.4458 129.43 22.3763C129.43 27.3068 132.735 30.4988 137.197 30.4988C141.009 30.4988 143.466 28.3043 144.341 25.5683Z"
            fill="#303A46"
          />
          <path d="M148.78 30.2423H152V9.15234H148.78V30.2423Z" fill="#303A46" />
        </svg>
      </div>
      <v-toolbar-side-icon @click.native="onChangeNavicationMini"></v-toolbar-side-icon>
    </div>
    <div class="search__input" v-show="this.$store.getters.userProfile" :style="styteInputWrapper">
      <input
        placeholder="Tìm kiếm"
        class="input_search"
        :style="styleInput"
        :class="{
          'full-width mt-2': isMobile
        }"
        @input="handleOnChangeSearchTermMenu"
      />
    </div>
  </div>
</template>
<script>
import { getItemStorage } from '../../../plugins/util'

export default {
  name: 'HeaderSidebarV2',
  props: {
    handleSearchMenu: {
      type: Function
    },
    changeNavicationMini: {
      type: Function
    }
  },
  methods: {
    handleOnChangeSearchTermMenu(event) {
      const searchTerm = event.target.value
      this.$emit('handleSearchMenu', searchTerm)
    },
    onChangeNavicationMini() {
      this.$emit('changeNavicationMini')
    }
  },
  computed: {
    darkTheme() {
      const theme =
        this.$store.getters.theme || getItemStorage('darkTheme') === 'true' ? true : false
      if (!theme) return false
      return theme
    },

    styteInputWrapper() {
      if (this.darkTheme) {
        return {
          borderRadius: '5px',
          border: '1px solid rgba(9, 30, 66, 0.14)',
          background: '#fff'
        }
      }
      return {
        borderRadius: '5px',
        border: '1px solid var(--light-color-border-input, rgba(9, 30, 66, 0.14))',
        background: '#fff'
      }
    },
    styleInput() {
      if (this.darkTheme) {
        return {
          color: '#697077'
        }
      }
      return {
        color: '#697077'
      }
    }
  }
}
</script>
<style scoped lang="scss">
.header_v2__container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 48px;
  height: 100%;

  @media (max-width: 400px) {
    padding-right: 24px;
  }

  .logo {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    width: 100%;
    z-index: 1000;

    .v-toolbar__side-icon {
      margin-right: 0;
      margin-top: 3px;

      &:hover {
        background: transparent;
      }
    }

    .box-logo {
      max-width: 151px;
      max-height: 40px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .search__input {
    width: 100%;
    background: rgba(255, 255, 255, 0.07);
    border-radius: 5px;

    input {
      background: url(/assets/images/icons/SearchOutline.svg) no-repeat 7px 7px;
      padding-left: 40px;
      padding-right: 8px;
      border-radius: 5px;
      border: 1px solid rgba(255, 255, 255, 0.15);
      width: 100%;
      background-position-x: 12px;
      background-position-y: 7px;
      padding-bottom: 0;
      color: #fff;
      padding-top: 0;
      height: 40px;
      @media (max-width: 400px) {
        margin-top: 0 !important;
      }

      &::placeholder {
        //color: rgba(255, 255, 255, 0.8);
        font-size: 14px;
        font-weight: 500;
      }
    }
  }
}
</style>
